export default __webpack_public_path__ + "68f9b9c311f3f488d2c6717211023939.png";